import { Component, Input } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { OrderDetailAttributes } from '@albatrosdeveloper/ave-models-package';
import { DecimalStockCompanyPipe } from 'app/pipes/decimal-stock-company.pipe';

@Component({
    selector: 'app-location-resume-cell-renderer',
    standalone: true,
    imports: [CommonModule, DecimalPipe, DecimalStockCompanyPipe],
    template: `
                                                    {{params.data.locationTwo && params.data?.locationThree ?
                                                    params.data.locationTwo?.name + ' - ' + params.data?.locationThree?.name :
                                                    (params.data.locationTwo?.name || params.data.locationTwo?.name)}}
  `,
})
export class LocationResumeCellRendererComponent implements CellRenderer<any> {
    @Input() params!: CellRendererParams<any>;
}
